// extracted by mini-css-extract-plugin
export var standaloneTable = "_24-0";
export var standaloneTableWithBodyFill = "_24-1";
export var withExtraHeader = "_24-2";